import Table from '@/components/Table/Table.jsx'
import TableChooseComponent from '../_COMPONENT/TableChooseExternalComponent.jsx'
import {useTableColumnRmName, useTableColumnRmNo} from '../RULEMRM/TableChooseRulemrm.jsx'

export default function TableChooseRulemrmrule(props) {
    const columns = [
        useTableColumnRmName(),
        useTableColumnRmNo(),

        {
            title: '重要规则代码',
            dataIndex: 'ruleUserCode',
            component: <Table.ViewText />,
        },

        {
            title: '重要规则标题',
            dataIndex: 'ruleTitle',
            component: <Table.ViewText />,
        },
    ]

    return (
        <TableChooseComponent
            columns={columns}
            rowKey="pkid"
            {...props}
        />
    )
}
